<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md-1">
            <i style="font-size: 80px; color: grey" class="fa fa-file"></i>
          </div>
          <div class="col-md-11">
            <h4 class="title-card">Patologías (CIE10)</h4>
            <small>Administra las patologías registradas en AVANTI</small>
          </div>
        </div>
      </div>

      <div class="card-content">
        <div class="row">
          <div class="col-sm-9">
            <label>
              <input
                type="search"
                class="form-control"
                placeholder="Buscar patología..."
                v-model="searchQuery"
              />
            </label>
            <!-- <div class="pull-right">
              <el-select
                class="select-default"
                style="border-radius: 0px !important"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div> -->
          </div>
          <div class="col-sm-2 px-2">
            <button class="btn btn-success btn-fill" @click="abrirModal()">
              <i class="ti-plus"></i> Nueva Patología
            </button>
          </div>

          <div class="col-md-12">
            <br />
            <download-excel
              class="btn btn-info btn-fill"
              style="border-radius: 5px"
              :data="arrayPatologias"
              :fields="json_cie10"
              worksheet="My Worksheet"
              :name="'cie10'"
            >
              Exportar a excel
            </download-excel>
          </div>
        </div>

        <!-- <center> -->
        <div class="row">
          <br />
          <el-table
            class="table-striped"
            :data="queriedData"
            border
            max-height="400"
            style="width: 100%"
          >
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              else
            >
            </el-table-column>
            <el-table-column width="100" label="Tipo">
              <template slot-scope="props">
                <p v-if="props.row.DomTip == 1">CIE10</p>
                <p v-if="props.row.DomTip == 2">DSM4</p>
              </template>
            </el-table-column>
            <el-table-column width="100" label="Estado">
              <template slot-scope="props">
                <p
                  v-if="props.row.DomEst == 1"
                  slot="title-label"
                  class="label label-success"
                >
                  Activo
                </p>
                <p v-else slot="title-label" class="label label-danger">
                  Inactivo
                </p>
              </template>
            </el-table-column>
            <el-table-column :min-width="40" fixed="right" label="">
              <template slot-scope="props">
                <button
                  v-if="props.row.DomEst == 2"
                  class="btn btn-simple btn-xs btn-info btn-icon check"
                  @click="activar(props.row)"
                >
                  <i class="ti-check"></i>
                </button>
                <button
                  v-else
                  class="btn btn-simple btn-danger"
                  @click="desactivar(props.row)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </template>
            </el-table-column>
          </el-table>

          <div class="col-sm-6 pagination-info">
            <br />
            <p class="category">
              Mostrando del {{ from + 1 }} al {{ to }} de {{ total }} registros
            </p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
            >
            </p-pagination>
          </div>
        </div>
        <!-- </center> -->
      </div>

      <!-- 
            primer modal-->
      <div
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        :class="{ mostrar: modalRegistrar }"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header CM" style="padding: 8px">
              <strong class="modal-title" id="exampleModalLongTitle">
                <i class="fa fa-graduation-cap"></i>
                Nueva Patología
              </strong>
              <button
                type="button"
                @click="modalRegistrar = 0"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="nuevoDominio">
                <label for>Descripción:</label>
                <textarea
                  v-model="descripcion"
                  required
                  cols="30"
                  rows="3"
                  class="form-control"
                ></textarea>

                <br />
                <label for>Clasificación:</label>
                <br />
                <div class="row">
                  <div class="col-md-6">
                    <input v-model="tipo" value="1" type="radio" />
                    <label for>CIE10</label>
                  </div>
                  <!-- <div class="col-md-6">
                            <input v-model="tipo" value="2" type="radio" />
                            <label for>DSM4</label>
                          </div> -->
                </div>

                <br />
                <br />

                <center>
                  <button type="submit" class="btn btn-success btn-sm">
                    <i class="fa fa-plus"></i> Agregar patología
                  </button>
                  <button
                    type="button"
                    @click="limpiarFormulario()"
                    class="btn btn-danger btn-sm"
                  >
                    Limpiar formulario <i class="fa fa-refresh"></i>
                  </button>
                </center>
              </form>
            </div>
            <center></center>
            <br />
          </div>
        </div>
      </div>
      <!-- fin primer modal -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);

export default {
  data() {
    return {
      //   configuracion
      ip: "https://avanti-erp.com/",
      descripcion: "",
      tipo: 1,
      arrayPatologias: [],
      modalRegistrar: 0,

      //   notificaciones
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false,
      },

      //   tabla
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["DomDes"],
      tableColumns: [
        {
          prop: "DomDes", //NOMBRE DEL CAMPO TAL CUAL COMO ESTÁ EN LA BASE DE DATOS
          label: "Nombre", //NOMBRE QUE QUIERES QUE SE REFLEJE EN EL ENCABEZADO DE CADA COLUMNA
          minWidth: 400, //ANCHO DE LA COLUMNA
        },
      ],
      json_cie10: {
        "Codigo CIE 10": "cod_pat",        
        'descripción': "DomDes",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  components: {
    PPagination,
  },
  computed: {
    pagedData() {
      return this.arrayPatologias.slice(this.from, this.to);
    },
    /*
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.arrayPatologias.length;
        return this.pagedData;
      }
      let result = this.arrayPatologias.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString().toLowerCase();
          if (
            rowValue.includes &&
            rowValue.includes(this.searchQuery.toLowerCase())
          ) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.arrayPatologias.length;
      return this.arrayPatologias.length;
    },
  },

  methods: {
    nuevoDominio() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      let vm = this;
      var url = this.ip + "api/nuevoDominio";
      axios
        .post(
          url,
          {
            descripcion: this.descripcion,
            tipo: this.tipo,
          },
          config
        )
        .then((response) => {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: ` <div style="padding: 3%;">
              <span><b> REGISTRADO CON ÉXITO </b>.</span>
              </div>
              `,
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type[color],
          });
          this.modalRegistrar = 0;
          this.tipo = 1;
          this.descripcion = "";
          this.patologias();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    patologias() {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      let vm = this;
      var url = this.ip + "api/patologias";
      axios
        .get(url, config)
        .then((response) => {
          vm.arrayPatologias = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    limpiarFormulario() {
      this.descripcion = "";
      this.tipo = 1;
    },
    desactivar(patologia = []) {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const url = this.ip + "api/desactivarDominio";
      axios
        .put(
          url,
          {
            id: patologia.DomIde,
          },
          config
        )
        .then((response) => {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: ` <div style="padding: 3%;">
              <span><b> DESACTIVADO CON ÉXITO </b>.</span>
              </div>
              `,
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type[color],
          });
          this.patologias();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    activar(patologia = []) {
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      const url = this.ip + "api/activarDominio";
      axios
        .put(
          url,
          {
            id: patologia.DomIde,
          },
          config
        )
        .then((response) => {
          var color = Math.floor(Math.random() * 4 + 1);
          this.$notify({
            component: {
              template: ` <div style="padding: 3%;">
              <span><b> ACTIVADA CON ÉXITO </b>.</span>
              </div>
              `,
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: this.type[color],
          });
          this.patologias();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    abrirModal() {
      this.modalRegistrar = 1;
    },
  },
  mounted() {
    // console.log("Component mounted.");
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.patologias();
    }
  },
};
</script> 
<style scoped>
.mostrar {
  display: list-item !important;
  opacity: 1 !important;
  position: absolute !important;
  background-color: #3c29297a;
  padding-top: 15%;
}
.modal-content {
  width: 100% !important;
  position: absolute !important;
}

.title-card {
  color: grey;
  margin-top: 4% !important;
  margin-bottom: 0% !important;
}

.btn {
  border-radius: 5px;
}

.card {
  box-shadow: 0 0 0 0;
  border-radius: 15px;
  padding: 2%;
}

.titulo-mensaje {
  font-size: 15px;
  color: grey;
}

.el-table {
  border-radius: 10px;
}

.select-default .el-input {
  border-radius: 0px !important;
}

.card-header {
  padding-bottom: 10px !important;
  background-color: #f3f2ee;
  border-radius: 15px !important;
}

.label {
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Mantenimiento/mantenimiento-patologias.vue